import { render, staticRenderFns } from "./StrategyAdd.vue?vue&type=template&id=a8ac9f20&scoped=true&"
import script from "./StrategyAdd.vue?vue&type=script&lang=js&"
export * from "./StrategyAdd.vue?vue&type=script&lang=js&"
import style0 from "./StrategyAdd.vue?vue&type=style&index=0&id=a8ac9f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ac9f20",
  null
  
)

export default component.exports